<template>
    <div class="white">
        <div style="overflow: hidden;"
             v-resize="onResize"
             :class="background"
        >
            <div
                v-if="!loading"
                class="mb-1"
                style="height: 4px;"
            ></div>

            <v-progress-linear
                v-if   = "loading"
                color  = "primary"
                height = "5"
                class  = "w-100 mb-1"
                indeterminate
            />

            <v-expansion-panels accordion flat class="mb-1" v-model="expandFilter" v-if="showTitle" style="background-color: white">
                <v-expansion-panel class="pa-0" :key="1" style="background-color: white">
                    <v-expansion-panel-header :ripple="false" expand-icon="" class="pa-0" style="background-color: white">
                        <c-column-header
                            :label = "label"
                            :class = "headerColor"
                            :title-border = "titleBorder"
                            style  = "font-size: 16px; max-width: calc(100% - 12px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;"
                        >
                            <template v-slot:pre>
                                <div v-if="titlePrefix">
                                    <slot name="prefix" />
                                </div>
                                <a @click.stop="onClose" v-if="!zoom && leftArrow && !titlePrefix">
                                    <v-icon size="20" class="pr-1 white--text">mdi-arrow-left-bold</v-icon>
                                </a>
                            </template>
                            <template v-slot:toolbar>
                                <slot name="toolbar"></slot>
                            </template>

                            <template v-slot:filter>
                                <div class="v-flex" style="margin-top: -2px">
                                    <c-item-count :count="count" :key="count" v-if="showCount" />
                                    <a @click.stop="onFilter"  v-if="showFilter">
                                        <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                                    </a>
                                    <a @click.stop="onRemoveFilter"  v-if="showFilter && searchtext">
                                        <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                                    </a>
                                    <!--
                                    <a @click.stop="onZoom" v-if="zoom">
                                        <v-icon size="20" class="pr-1 white--text">mdi-arrow-expand-all</v-icon>
                                    </a>
                                    -->
                                </div>
                            </template>
                        </c-column-header>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content eager class="pa-0 ma-0" style="padding-right: 10px!important;">
                        <div class="lm-border mt-1  mb-1 pa-3 pt-0 " :style="styleSearch" v-if="enableSearch">
                            <div class="pb-1">
                                <v-text-field
                                    v-model        = "searchtext"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                    append-icon    = "fas fa-search"
                                    ref            = "searchfield"
                                    @input         = "onSearch"
                                    :clearable     = "true"
                                    hide-details
                                />
                            </div>

                            <slot name="filter"  />
                        </div>
                        <div v-if="!enableSearch" class="mt-1 mb-1">
                            <slot name="filter"  />
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-fade-transition>
                <div :style="'max-height:' + scrollHeight + 'px; height:' + scrollHeight + 'px;'" :class="background">
                    <virtual-scroller
                        v-if          = "items && scrollerType !== 'vuetify'"
                        ref            = 'scroller'
                        :items         = "filteredItems"
                        :min-item-size = "itemHeight ? itemHeight + itemGap : null"
                        :item-size     = "itemHeight ? itemHeight + itemGap : null"
                        :key-field     = "keyField"
                        :prerender     = "0"
                        :style         = "'max-height:' + scrollHeight + 'px'"
                        style          = "width: calc(100% - 2px)"
                    >
                        <div slot-scope="{ item, index }" class="">
                            <slot name="card" v-bind:item="{ data: item, index: index }" />
                        </div>
                    </virtual-scroller>

                    <v-virtual-scroll
                        v-if         = "items && scrollerType === 'vuetify'"
                        :items       = "filteredItems"
                        :height      = "scrollHeight"
                        :item-height = "itemHeight + itemGap"
                        bench="1"
                        :key="xxx"
                    >
                        <template v-slot:default="{ item }">
                            <div style="padding-right: 4px">
                                <slot name="card" v-bind:item="item" />
                            </div>
                        </template>
                    </v-virtual-scroll>
                </div>
            </v-fade-transition>
        </div>
    </div>
</template>

<script>
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";
import CItemCount from "@/modules/core/components/utils/CItemCount";
export default {
    name: "CCardIterator",
    components: {
        CItemCount,
        CColumnHeader
    },

    props: {
        filter: {
            required: false,
            type    : Function,
        },

        items: {
            required: false,
            type    : Array,
            default: function () {
                return [];
            }
        },

        label: {
            required: false,
            default: function () {
                return null;
            }
        },

        loading: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        titleBorder: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        totalVisible: {
            required: false,
            type    : Number,
            default: function () {
                return 6;
            }
        },

        itemHeight: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },

        itemGap: {
            required: false,
            type    : Number,
            default: function () {
                return 10;
            }
        },

        paginationOn: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        titlePrefix: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        zoom: {
            required: false,
            type    : Boolean,
            default: function () {
                return true;
            }
        },

        leftArrow: {
            required: false,
            type    : Boolean,
            default: function () {
                return true;
            }
        },

        minHeight: {
            required: false,
            type    : Number,
            default: function () {
                return 150;
            }
        },

        height: {
            required: false,
            default: function () {
                return null;
            }
        },

        enableSearch: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        showFilter: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        showCount: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        filterHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        },

        headerColor: {
            required: false,
            type    : String,
            default : function () {
                return "primary";
            }
        },

        showTitle: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return "white";
            }
        },

        refreshOnFilter: {
            default: function () {
                return true;
            }
        },

        keyField: {
            required: false,
            type    : String,
            default : function () {
                return "id";
            }
        },

        scrollerType: {
            required: false,
            type    : String,
            default : function () {
                return "vuetify";
            }
        }
    },

    data: () => ({
        count: null,
        page: 1,
        searchtext: "",
        expandFilter: false,
        scrollHeight: null,
        itemsPerPage: 0,
        xxx: 0
    }),

    mounted() {
        this.onResize();
    },

    computed: {
        pageCount () {
            return Math.ceil(this.count / this.itemsPerPage);
        },

        styleSearch () {
            if (this.columns > 1) {
                return "width: calc(" + 100 / this.columns +"% - 10px);"
            }

            return "width: " + 100 / this.columns + "%;"
        },

        style () {
            return "width: calc(" + 100 / this.columns +"% - 15px);"
        },

        filteredItems () {
            return this.filterItems ();
        },

        filteredItems3Col () {
            const result = [];
            const items = this.filterItems ();
            let index = 0;
            while (index < items.length) {
                const list = [];
                list.push (items[index]);
                index ++;
                if (index < items.length) list.push (items[index]);
                index ++;
                if (index < items.length) list.push (items[index]);
                index ++;
                result.push(list);
            }

            return result;
        },
    },

    watch: {
        expandFilter () {
            this.$nextTick(() => {
                this.onResize();
            })
        },

        filterHeight () {
            this.onResize();
        }
    },

    methods: {
        onZoom () {
            this.$emit("zoom");
        },

        onClose () {
            this.$emit("close");
        },

        onSearch () {
            this.$emit("search", this.searchtext);
        },

        refresh () {
            this.xxx ++;
        },

        onFilter () {
            if (this.expandFilter !== 0) {
                this.expandFilter = 0;
            } else {
                this.expandFilter = undefined;
            }
        },

        onRemoveFilter () {
            this.searchtext = null;
            this.$emit("remove-filter");
            this.expandFilter = undefined;
            this.$emit("search", this.searchtext);
        },

        onResize () {
            this.scrollHeight = null;

            if (this.height) {
                if (this.expandFilter === 0) {
                    this.scrollHeight = this.height - this.filterHeight;
                } else {
                    this.scrollHeight = this.height;
                }

                return;
            }

            this.scrollHeight = window.innerHeight-this.minHeight;
            if (this.expandFilter === 0) {
                this.scrollHeight = this.scrollHeight - this.filterHeight;
            }

            this.itemsPerPage = Math.ceil(((this.scrollHeight * this.columns) - 5) / (this.itemHeight + this.itemGap)) - 1;
        },

        filterItems () {
            if (!this.filter) {
                this.count = this.items.length;
                if (this.refreshOnFilter) {
                    this.xxx ++;
                }
                return this.items;
            }

            const filtered = this.items.filter(item => this.filter(item, this.searchtext));
            this.count = filtered.length;
            if (this.refreshOnFilter) {
                this.xxx ++;
            }

            return filtered;
        },

        scrollTo (itemId) {
            const index = this.filteredItems.findIndex((item => item.id === itemId));
            if (index >= 0) {
                this.$refs.scroller.scrollToItem(index);
            }
        },
    }
}
</script>

<style scoped>

::v-deep .v-expansion-panel-content__wrap {
    margin: 0;
    padding: 0;
}

::v-deep .v-expansion-panel-header {
    min-height: 10px!important;
}

::v-deep .v-expansion-panel-header__icon {
    display: none;
}

::v-deep .v-virtual-scroll {
    overflow-y: scroll;
    overflow-x: hidden;
}

</style>